import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { XpoPreventCharactersDirective } from './prevent-characters.directive';

const directives = [XpoPreventCharactersDirective];

@NgModule({
  imports: [CommonModule],
  declarations: directives,
  exports: directives,
})
export class XpoPreventCharactersModule {}
